<br /><br /><br />

<!-- HEADER -->
<section id="header">
  <div class="row">
    <div class="col bg-header">
      <img
        src="./assets/img/fundoSiteDD.svg"
        class="imagemFundo w-100 img-fluid"
        alt=""
      />
    </div>
  </div>
</section>

<!-- CURSOS -->
<section id="cursos">
  <div class="row">
    <div class="container">
      <div class="col-12 mt-4">
        <h4 class="mb-0">Cursos</h4>
        <hr class="mt-0" />
      </div>
      <div class="card-deck">
        <div class="col-md-4 col-sm-12" *ngFor="let item of cursosLista">
          <div
            class="card border-0 shadow mb-3 nipsey"
            type="button"
            href=""
            [routerLink]="['/curso-view']"
          >
            <div class="card-body p-0">
              <img
                src="{{ item.imagem }}"
                class="img-fluid"
                alt="Imagem curso"
              />
              <div class="m-3 mt-0">
                <span class="small"
                  >{{ item.notaAvaliacao
                  }}<span> <i class="fas fa-star text-warning"></i> </span
                ></span>
                <h5 class="">{{ item.nomeCurso }}</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br /><br /><br /><br />
    </div>
  </div>
</section>

<br />

<!-- SEJA PROFESSOR -->
<section id="sejaProfessor" class="mt-3">
  <div class="container">
    <div class="row">
      <div class="col-md-7 col-sm-12 mt-5">
        <h1 class="font-lato-prof">É professor?</h1>
        <h1 class="font-prof">
          Tenha seu <span class="corCurso">curso</span> postado aqui!
        </h1>
        <p class="text-center w-75 margin-esquerda">
          <span class="font-lato text-secondary">Clique e inscreva-se</span>
        </p>
        <div class="mt-3 mb-3">
          <button
            class="btn text-white w-75 margin-esquerda corblue font-lato-btn"
            (click)="abrirProfessor()"
          >
            SOU PROFESSOR
          </button>
        </div>
      </div>
      <div class="col-md-5 col-sm-12">
        <img src="./assets/img/professorDD.svg" class="img-fluid" alt="" />
      </div>
    </div>
  </div>
</section>

<br /><br /><br /><br />

<!-- AVALIACOES -->
<section id="avaliacoes" class="mt-3">
  <div class="container">
    <div class="row">
      <div class="col-12 mt-4">
        <h4 class="mb-0">Avaliações</h4>
        <hr class="mt-0" />
      </div>
      <div class="col-md-6 col-sm-12 mb-3" *ngFor="let i of avaliacoesLista">
        <div class="card rounded border-0 shadow">
          <div class="row">
            <div class="col-4 my-auto">
              <img src="{{ i.img }}" class="img-fluid rounded-circle" alt="" />
            </div>
            <div class="col-8">
              <h5 class="mt-2">{{ i.cursoNome }}</h5>
              <p class="">
                {{ i.autor }}
                <span class="float-right mr-3">
                  <i class="fas fa-star text-warning"></i>
                  {{ i.avaliacao }}</span
                >
              </p>
              <p class="small">{{ i.comentario }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<br /><br /><br /><br /><br />

<!-- MODAL SOU PROFESSOR -->
<ng-template #modalSouProfessor>
  <div class="modal-header border-0 p-1 m-0">
    <button type="button" class="close cardM mr-2 mt-2" (click)="decline()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body mt-0">
    <div class="text-center">
      <h1 class="font-lato">É professor?</h1>
      <h3 class="font-lato">
        Tenha seu curso <span class="corCurso">online</span> na nossa
        plataforma!
      </h3>
      <h6 class="font-lato text-secondary">
        Digite seus dados que entraremos em contato
      </h6>
    </div>
    <div class="row mt-5 mb-3">
      <div class="col-md-6 col-sm-12">
        <label for="" class="mb-0"
          >Nome e sobrenome<span class="text-danger">*</span>
        </label>
        <input type="text " class="form-control" />
      </div>
      <div class="col-md-6 col-sm-12">
        <label for="" class="mb-0"
          >Whatsapp<span class="text-danger">*</span></label
        >
        <input type="number " inputmode="numeric" class="form-control" />
      </div>
      <div class="col-12 mt-2">
        <label for="" class="mb-0"
          >Email<span class="text-danger">*</span></label
        >
        <input type="text " class="form-control" />
      </div>
    </div>
  </div>
  <div class="text-center modal-footer border-0">
    <button class="btn mx-auto w-50 font-lato corblue text-white font-lato-btn">
      ENVIAR
    </button>
  </div>
</ng-template>
